exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login_wrapper[data-v-32dbfdbe]{justify-content:center;height:100%}.login_wrapper[data-v-32dbfdbe],.login_wrapper div[data-v-32dbfdbe]{display:flex;align-items:center}.login_wrapper div .login[data-v-32dbfdbe]{padding:8px 10px;border-radius:2px;border:1px solid #409eff;margin:24px;color:#409eff;white-space:nowrap}", ""]);

// exports
